var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("NotificationBell", {
    ref: "bell",
    attrs: {
      notifications: _vm.notifications,
      loading: !!_vm.notificationsStatus.loading,
      error: _vm.notificationsStatus.error
        ? "No se han podido actualizar las notificaciones."
        : "",
      "downloading-id": _vm.fileStatus.downloading ? _vm.fileId : null,
    },
    on: {
      open: _vm.loadNotifications,
      refresh: _vm.refreshNotifications,
      close: _vm.cancelDownload,
      download: _vm.downloadAttachment,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }